import MainLayout from 'components/layout/MainLayout';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import PageTitle from 'components/PageTitle';
import Subheading from 'components/Subheading';
import { NextSeo } from 'next-seo';
import Link from 'next/link';

const ComplaintsPage = () => {
  return (
    <MainLayout>
      <NextSeo
        title="Complaints | DAYMADE"
        openGraph={{
          title: 'Complaints | DAYMADE',
        }}
      />

      <PageTitle>Complaints</PageTitle>

      <PaddedMaxWidthContainer id="complaintsPage" style={{ padding: '3em 0' }}>
        <p>
          DAYMADE views complaints as an opportunity to learn and improve for
          the future, as well as a chance to put things right for the person (or
          organisation) that has made the complaint.{' '}
        </p>
        <Subheading>PRINCIPLES OF COMPLAINTS PROCEDURE</Subheading>
        <p>We seek to ensure that complaints are:</p>
        <ul>
          <li>Listened to and investigated thoroughly</li>
          <li>Dealt with consistently throughout DAYMADE</li>
          <li>Acknowledged speedily and recorded</li>
          <li>Dealt with in an appropriate, fair and timely manner</li>
          <li>Learned from</li>
        </ul>
        <Subheading>COMPLAINTS PROCEDURE</Subheading>
        <p>
          If you would like to make a complaint, you can contact us using the
          following options:
        </p>
        <ul>
          <li>
            Email us at 
            <a href="mailto:hello@daymade.co.uk">hello@daymade.co.uk</a> with
            the subject 'Official Complaint'
          </li>
          <li>
            Write to us:{' '}
            <strong>
              DAYMADE LTD 36 Fifth Avenue Havant, Hampshire, PO9 2PL
            </strong>
          </li>
        </ul>
        <p>
          Once received, all complaints will be investigated as appropriate and
          complainants will be informed of the outcome in writing within 28 days
          of DAYMADE acknowledging the complaint. If you are not happy with our
          response, please let us know as soon as possible. Your complaint will
          be referred to a more senior member of staff, who will carry out a
          review and let you know the outcome. If you remain dissatisfied with
          our response, you can refer your complaint to the Fundraising
          Regulator within two months of receiving the response from DAYMADE.{' '}
        </p>

        <Subheading>YOUR PERSONAL INFORMATION</Subheading>
        <p>
          If you use our complaints procedure, you are agreeing that we can use
          any personal information you send us for purposes connected with your
          complaint. DAYMADE will retain information about complaints in
          accordance with DAYMADE's{' '}
          <Link href="/privacy-policy">Privacy Policy</Link> and with the
          Fundraising Regulator's Terms and Conditions and will provide
          information and communications relating to complaints to the
          Fundraising Regulator where requested.
        </p>
        <style jsx>
          {`
            :global(#complaintsPage p),
            :global(#complaintsPage li),
            :global(#complaintsPage ul) {
              text-align: left;
              width: 100%;
              font-weight: 600;
            }

            :global(#complaintsPage .subheading) {
              font-size: 1.4rem;
              text-align: left;
              width: 100%;
            }
          `}
        </style>
      </PaddedMaxWidthContainer>
    </MainLayout>
  );
};

export default ComplaintsPage;
